import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { useTranslation } from 'react-i18next';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { IWarranty } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import DeleteButton from '../../../components/buttons/DeleteButton';

const WarrantiesTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<IWarranty[]>) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });
  const { t, i18n } = useTranslation();

  const hasEditPermission = hasPermission(['accessories.edit'])

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header, index) => !header ? null : (
          <span className={`head ${header.customClass}`} key={index}>
            {header.label}
          </span>
        ))}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => (
              <div
                className={`item has_logo vehicle_makes`}
                key={index}
              >
                <div className="column">{item.id}</div>
                <div className="column">{item?.code || '-'}</div>
                <div className="column">
                  <div className="capitalize">{item?.title?.[i18n?.language as 'en' | 'ar'] || '-'}</div>
                </div>
                <div className="column">{item?.is_default ? t('yes') : t('no')}</div>
                {hasEditPermission && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/warranties/create-warranty/${item.id}`, navigate);
                      }}
                    >
                      {editIcon}
                    </div>
                    <DeleteButton deleteRoute={`/admin/warranties`} queryKey='warranties' id={item.id}/>
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default WarrantiesTableContainer;
